export const dateSorting =(a: any, b: any) => {
  const dateA = new Date(a.date).getTime();
  const dateB = new Date(b.date).getTime();
  return dateA > dateB ? -1 : 1;
};




export const getISOWeeksInMonth = (monthParam: number | null = null, yearParam: number | null = null) => {
  // Default to current month and year if parameters are null or undefined
  const month = monthParam ?? new Date().getMonth() + 1;
  const year = yearParam ?? new Date().getFullYear();

  // Start at the 1st of the month
  const weekStart = new Date(year, month - 1, 1);
  // Set to previous Monday (ISO week starts on Monday)
  weekStart.setDate(weekStart.getDate() - (weekStart.getDay() === 0 ? 6 : weekStart.getDay() - 1));
  // End of the week (Sunday)
  const weekEnd = new Date(weekStart);
  weekEnd.setDate(weekEnd.getDate() + 6);

  let weekNum = getWeekNumber(weekStart)[1];
  const weeks = [];

  const lastDayOfMonth = new Date(year, month, 0);

  // Iterate through all weeks that intersect the given month
  while (weekStart <= lastDayOfMonth || weekEnd <= lastDayOfMonth || (weekStart.getMonth() === month - 1 && weekStart.getFullYear() === year)) {
    weeks.push({
      weekNum: weekNum++,
      start: new Date(weekStart),
      end: new Date(weekEnd),
      dateKey: `${formatDate(weekStart)}-${formatDate(weekEnd)}`,
    });

    weekStart.setDate(weekStart.getDate() + 7);
    weekEnd.setDate(weekEnd.getDate() + 7);
    
    // Safety break to prevent infinite loop if logic fails
    if (weeks.length > 10) break; 
  }

  return weeks;
};



const  formatDate=(date:Date):string =>{
  const d = new Date(date);
  let month = '' + (d.getMonth() + 1);
  let day = '' + d.getDate();
  const year = d.getFullYear();

  if (month.length < 2) 
      month = '0' + month;
  if (day.length < 2) 
      day = '0' + day;

  return `${year}${month}${day}`;
}

 
export const getWeekNumber = (d:any) => {
    d = new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()));
    d.setUTCDate(d.getUTCDate() + 4 - (d.getUTCDay()||7));
    const yearStart:any = new Date(Date.UTC(d.getUTCFullYear(),0,1));
    const weekNo:any = Math.ceil(( ( (d - yearStart) / 86400000) + 1)/7);
    return [d.getUTCFullYear(), weekNo];
}
 


export const DATA_MONTHS = [
   {
      name: "January",
      short: "Jan",
      number: 1,
      days: 31
    },
    {
      name: "February",
      short: "Feb",
      number: 2,
      days: 28
    },
   {
      name: "March",
      short: "Mar",
      number: 3,
      days: 31
    },
    {
      name: "April",
      short: "Apr",
      number: 4,
      days: 30
    },
    {
      name: "May",
      short: "May",
      number: 5,
      days: 31
    },
    {
      name: "June",
      short: "Jun",
      number: 6,
      days: 30
    },
    {
      name: "July",
      short: "Jul",
      number: 7,
      days: 31
    },
    {
      name: "August",
      short: "Aug",
      number: 8,
      days: 31
    },
    {
      name: "September",
      short: "Sep",
      number: 9,
      days: 30
    },
    {
      name: "October",
      short: "Oct",
      number: 10,
      days: 31
    },
    {
      name: "November",
      short: "Nov",
      number: 11,
      days: 30
    },
    {
      name: "December",
      short: "Dec",
      number: 12,
      days: 31    
    }
];

const  currentYear = (new Date()).getFullYear();
const years_range = (start:number, stop:number, step:number) => Array.from({ length: (stop - start) / step + 1}, (_, i) => start + (i * step));
export const DATA_YEAR = years_range(currentYear,currentYear-10,-1);

